import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { BayclubsAlertService } from '@bayclubs/alert';
import { ErrorTranslationService, FormService } from '@bayclubs/utils';

import { camps } from '../../../../../models/models.generated';
import { CampManagementApiService } from '../../../../../services/api/camp-management-api.service';
import { CampsDetailsFormStateService } from '../../camp-details-form-state-service';

@Component({
    selector: 'app-camp-visibility-edit',
    templateUrl: './camp-visibility-edit.component.html',
    styleUrls: ['./camp-visibility-edit.component.scss'],
    standalone: false,
})
export class CampVisibilityEditComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    constructor(
        private state: CampsDetailsFormStateService,
        private api: CampManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit(): void {}

    public save() {
        var request = <camps.CampVisiblitySaveRequest>{
            campId: this.form.get('id').value,
            description: this.form.get('description').value,
            isVisibleToMembers: this.form.get('isVisibleToMembers').value,
            shortDescription: this.form.get('shortDescription').value,
            displayName: this.form.get('displayName').value,
            memberWeeklyPrice: this.form.get('memberWeeklyPrice').value,
            guestWeeklyPrice: this.form.get('guestWeeklyPrice').value,
        };

        this.api.saveVisibility(request).subscribe((x) => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.state.finishEdit(this.form);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });

        this.state.finishEdit(this.form);
    }

    public cancel() {
        this.state.finishEdit(this.form, false);
    }

    public onVisibleChange($event) {
        this.form.controls.isVisibleToMembers.setValue($event);
        FormService.updateValueAndValidity(this.form);
        this.changeDetector.detectChanges();
    }

    public isFormValid() {
        return FormService.isFormValid(this.form);
    }

    public get isVisible() {
        return this.form && this.form.get('isVisibleToMembers').value;
    }
}
